import React from "react";
import { Link } from "react-router-dom";
import XPlacement from "@/components/public/XPlacement";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
      <header className="text-center mb-12">
        <div className="eyebrow">About</div>
        <h1 className="font-anton text-4xl sm:text-6xl uppercase mt-3 leading-[0.95]">LiftedAtTheMoment is more than a clothing brand.<br /><span className="text-lifted-green">It's a connected lifestyle ecosystem.</span></h1>
      </header>

      <div className="flex justify-center mb-10">
        <XPlacement zone="about" variant="hero" alt="Lifted brand ambassador" />
      </div>

      <article className="prose-cosmic mx-auto max-w-2xl text-lifted-dim space-y-5 text-base leading-relaxed">
        <p>Lifestyle meets community. Each LiftedAtTheMoment release is a meticulously crafted capsule collection — limited drops, bold prints, and a sensibility that treats every shirt, every pair of shorts, every accessory as part of a bigger story.</p>
        <p>What started as a clothing brand has grown into a connected lifestyle: gear, accessories, premium glass + smoke accessories, and the Lifted Supplies same-day delivery network. We work with creators, drivers, partner shops, and franchise operators to build something that feels real, local, and aligned with our community.</p>
        <p>The Lifted Affiliate Program — Lift-Off, Orbit, Galaxy, Cosmos — is how we share the upside. No pay-to-level-up. Levels unlock through referrals. Start where you are. Grow at your pace.</p>
        <p className="text-lifted-text font-anton uppercase text-2xl">This is more than a business.<br />It's a movement. It's a legacy.</p>
      </article>

      <div className="text-center mt-12 flex justify-center gap-3 flex-wrap">
        <Link to="/shop" className="btn-lifted" data-testid="about-cta-shop">Shop the capsule</Link>
        <Link to="/affiliate-zone" className="btn-ghost" data-testid="about-cta-affiliate">Join the network</Link>
        <Link to="/contact" className="btn-ghost" data-testid="about-cta-contact">Contact us</Link>
      </div>
    </div>
  );
}
